'use client'

import React from 'react'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import { Button, ButtonLink } from '@kiao-voice/ui-kit'
import { EndCta } from '@/components/site/end-cta'
import { useAuthModal } from '@/features/auth/auth-modal-provider'
import { trackSiteLinkClicked } from '@/lib/analytics'

export function MeetingNotesEndCta() {
  const { t } = useTranslation(['web'])
  const { open } = useAuthModal()
  return (
    <EndCta
      titleKey="web:meetingNotesPage.endCta.title"
      lead={t('web:meetingNotesPage.endCta.lead')}
      actions={
        <>
          <Button variant="onlight" size="marketing" onClick={() => open()}>
            {t('web:meetingNotesPage.endCta.primaryCta')}
          </Button>
          <ButtonLink
            as={Link}
            variant="ondark"
            size="marketing"
            href="/pricing"
            onClick={() => trackSiteLinkClicked('end_cta', '/pricing')}
          >
            {t('web:meetingNotesPage.endCta.secondaryCta')}
          </ButtonLink>
        </>
      }
      meta={t('web:meetingNotesPage.endCta.meta')}
    />
  )
}
